import { Table } from "antd"
import { MontosConvenio } from "../useConveniosPagoAPI"
import { useEffect, useState } from "react"

export interface PreviewConvenioProps {
    montos: MontosConvenio
    cuotas: number
}

export default (props: PreviewConvenioProps) => {
    const [montosArr, setMontosArr] = useState<any[]>([])
    const [montoTotalSinDescuento, setMontoTotalSinDescuento] = useState(0)
    const formatNumber = (n: number) => {
        return n.toLocaleString("es-AR", { maximumFractionDigits: 2, minimumFractionDigits: 2 })
    }
    useEffect(() => {
        const arr: any[] = []
        let newMontoTotalSinDescuento = 0
        for (const id in props.montos.montosInfracciones) {
            const m = props.montos.montosInfracciones[id];
            const montoInfraccionSinDescuento = m.montoInfraccion / (1 - (props.montos.porcentajeDescuento / 100))
            newMontoTotalSinDescuento += montoInfraccionSinDescuento + m.montoGastosAdministrativos
            arr.push(
                {
                    id: id,
                    montoTotalSinDescuento: "$" + formatNumber(m.montoGastosAdministrativos + montoInfraccionSinDescuento),
                    montoTotal: "$" + formatNumber(m.montoGastosAdministrativos + m.montoInfraccion),
                    montoInfraccion: "$" + formatNumber(m.montoInfraccion),
                    montoInfraccionSinDescuento: "$" + formatNumber(montoInfraccionSinDescuento),
                    montoGastosAdministrativos: "$" + formatNumber(m.montoGastosAdministrativos)
                }
            )
        }
        setMontoTotalSinDescuento(newMontoTotalSinDescuento)
        setMontosArr(arr)
    }, [props.montos])
    return (
        <Table
            pagination={false}
            footer={() =>
                <div>
                    <div>Monto total ({`${Object.keys(props.montos.montosInfracciones).length} ${Object.keys(props.montos.montosInfracciones).length > 1 ? "infracciones" : "infracción"}`}): <strong>${formatNumber(montoTotalSinDescuento)}</strong></div>
                    <div>Monto total c/descuento: <strong>${formatNumber(props.montos.montoTotal)}</strong></div>
                    <div><strong style={{ color: '#389e0d' }}>Los valores son expresados tomando en cuenta la cotización de la UF actualizada</strong></div>
                    {props.cuotas > 1 && <div>
                        <p style={{ color: '#389e0d' }}>
                            <strong>El monto total se dividirá en {props.cuotas} cuotas iguales. </strong>
                            Importe por cuota: <strong>${formatNumber(props.montos.montoTotal / props.cuotas)}</strong>
                        </p>
                        
                    </div>}
                </div>}
            dataSource={montosArr}
            columns={[
                { title: "Id", dataIndex: "id", key: "id" },
                { title: "Gastos administrativos", dataIndex: "montoGastosAdministrativos", key: "montoGastosAdministrativos" },
                { title: "Monto infracción", dataIndex: "montoInfraccionSinDescuento", key: "montoInfraccionSinDescuento" },
                { title: "Monto infracción c/descuento", dataIndex: "montoInfraccion", key: "montoInfraccion" },
                { title: "Monto total", dataIndex: "montoTotalSinDescuento", key: "montoTotalSinDescuento" },
                { title: "Monto total c/descuento", dataIndex: "montoTotal", key: "montoTotal" },
            ]}
        />
    )
}